import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

const de = (iso) => new Date(iso).toLocaleDateString("de-DE", { day: "2-digit", month: "2-digit", year: "numeric" });

export default function ApprovalWarningsBanner({ showLink = true }) {
  const [warns, setWarns] = useState([]);
  useEffect(() => { api.get("/measure-approvals/warnings").then((r) => setWarns(r.data)).catch(() => {}); }, []);
  if (!warns.length) return null;
  return (
    <div className="mb-8 border border-amber-300 bg-amber-50 p-5" data-testid="approval-warnings-banner">
      <div className="flex items-center gap-2 text-sm font-medium text-amber-900 mb-2">
        <AlertTriangle size={16} /> Zulassung läuft bald aus – bitte Verlängerung bzw. Rezertifizierung beantragen
      </div>
      <ul className="text-sm text-amber-900 space-y-1">
        {warns.map((w) => (
          <li key={`${w.measure_id}-${w.type}`} data-testid={`approval-warning-${w.measure_id}-${w.type}`}>
            <span className="font-medium">{w.name}</span>{w.number ? ` (${w.number})` : ""} · {w.label} gültig bis {de(w.end_date)} ·{" "}
            <span className={w.days_left < 0 ? "text-rose-700 font-semibold" : ""}>{w.days_left < 0 ? "abgelaufen" : `noch ${w.days_left} Tage`}</span>
          </li>
        ))}
      </ul>
      {showLink && <Link to="/traeger?tab=zulassungen" className="inline-block mt-3 text-xs underline underline-offset-4 text-amber-900" data-testid="approval-warnings-link">Zu den Maßnahmen-Zulassungen</Link>}
    </div>
  );
}
